/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "hull--sprite",
  "use": "hull--sprite-usage",
  "viewBox": "0 0 29 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 30\" id=\"hull--sprite\"><path d=\"m25.865 18.796-3.434 2.16.52.846 2.034-1.28c-.191 1.119-.74 3.053-2.305 4.647-1.756 1.788-4.349 2.736-7.709 2.82V9.61h3.369v-.996h-3.369v-2.22a2.703 2.703 0 0 0 2.203-2.668c0-1.503-1.21-2.726-2.696-2.726-1.486 0-2.696 1.223-2.696 2.726 0 1.321.933 2.43 2.203 2.668v2.22h-3.369v.996h3.37v18.38c-3.356-.084-5.944-1.031-7.694-2.815-1.565-1.597-2.108-3.54-2.294-4.662l2.052 1.29.52-.848-3.435-2.16L1 22.269l.837.527 1.206-1.962c.237 1.341.87 3.328 2.544 5.037C7.62 27.948 10.61 29 14.478 29c3.868 0 6.862-1.052 8.901-3.128 1.688-1.72 2.326-3.714 2.564-5.06l1.22 1.983.837-.527-2.135-3.472Zm-11.387-16.8c.943 0 1.71.777 1.71 1.73 0 .954-.767 1.73-1.71 1.73s-1.71-.776-1.71-1.73c0-.953.767-1.73 1.71-1.73Z\" fill=\"#232323\" stroke=\"#232323\" stroke-width=\".4\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
